import { ConsentFormsStatusPatientView, useFormsView } from '@hb/react-web'
import { SignOnStagePanel } from './SignOnStagePanel'

export const SignOnConsentFormsStatus = () => {
  const {
    signOnData: {
      consentFormsStatus,
      consentFormsStatus: { complete },
    },
    populatedUser: { patientRef },
  } = useFormsView()
  return (
    <SignOnStagePanel
      title="Consent Forms"
      isLast
      buttonText={complete ? 'View Signed Consent Forms' : 'Complete Consent Forms'}
      complete={complete}>
      <ConsentFormsStatusPatientView
        consentFormsStatus={consentFormsStatus}
        patientId={patientRef?.id ?? null}
      />
    </SignOnStagePanel>
  )
}
